exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".save-date{color:#5894b4}.cancel-date,.save-date{font-size:1.2rem;margin:auto}.cancel-date{color:#e3342f}.edit-email{font-size:.9rem;color:#5894b4;float:right}.soc-col{max-width:200px;width:200px}.perm-col{max-width:150px;width:150px}.typ-col{max-width:400px;width:400px;min-width:340px}.ctg-group{margin-bottom:0!important}.ctg-group .custom-control-inline{font-size:.8rem!important;min-height:0!important}", ""]);

// exports
